import { Link } from 'react-router-dom';
import { APP_NAME, ROUTE_NAMES } from '@tsgecart/config';

const LINK_COLUMNS = [
  {
    heading: 'Company',
    links: [
      { label: 'About Us', to: ROUTE_NAMES.about },
      { label: 'Careers', href: '#' },
      { label: 'Contact Us', to: ROUTE_NAMES.contact },
    ],
  },
  {
    heading: 'Help',
    links: [
      { label: 'Track Order', to: ROUTE_NAMES.trackOrder },
      { label: 'Returns & Refunds', href: '#' },
      { label: 'FAQs', href: '#' },
    ],
  },
  {
    heading: 'Legal',
    links: [
      { label: 'Terms of Service', href: '#' },
      { label: 'Privacy Policy', href: '#' },
      { label: 'Shipping Policy', href: '#' },
    ],
  },
] as const;

const PAYMENT_METHODS = ['UPI', 'Visa', 'Mastercard', 'RuPay', 'Cash on Delivery'];

/** Static company/link/trust-badge footer -- no backend, placeholder links are fine per the storefront-shell spec. */
export function SiteFooter() {
  return (
    <footer className="mt-12 border-t border-gray-100 bg-gray-50">
      <div className="mx-auto grid max-w-6xl grid-cols-2 gap-8 px-4 py-10 sm:px-8 md:grid-cols-4">
        <div className="col-span-2 md:col-span-1">
          <p className="text-lg font-bold text-gray-900">{APP_NAME}</p>
          <p className="mt-2 max-w-xs text-sm text-gray-500">
            Fresh groceries and daily essentials, delivered to your door in minutes.
          </p>
        </div>
        {LINK_COLUMNS.map((column) => (
          <div key={column.heading}>
            <p className="text-sm font-semibold text-gray-900">{column.heading}</p>
            <ul className="mt-3 flex flex-col gap-2 text-sm text-gray-500">
              {column.links.map((link) => (
                <li key={link.label}>
                  {'to' in link ? (
                    <Link to={link.to} className="hover:text-brand-foreground hover:underline">
                      {link.label}
                    </Link>
                  ) : (
                    <a href={link.href} className="hover:text-brand-foreground hover:underline">
                      {link.label}
                    </a>
                  )}
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      <div className="border-t border-gray-100 px-4 py-4 sm:px-8">
        <div className="mx-auto flex max-w-6xl flex-col items-center justify-between gap-3 text-xs text-gray-400 sm:flex-row">
          <p>&copy; {new Date().getFullYear()} {APP_NAME}. All rights reserved.</p>
          <ul className="flex flex-wrap items-center gap-2" aria-label="Accepted payment methods">
            {PAYMENT_METHODS.map((method) => (
              <li key={method} className="rounded-md border border-gray-200 bg-white px-2 py-1 font-medium">
                {method}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </footer>
  );
}
